import React from "react"
import type { ReactNode } from "react"
import cx from "classnames"
import Cards from "./cards"

const DEFAULT = "bg-white border rounded p-4"

export type CardProps = {
  /** Content rendered inside the card */
  children?: ReactNode
  /** Show a visible border */
  border?: boolean
  /** Additional CSS classes */
  className?: string
  /** @deprecated */
  style?: React.CSSProperties
  /** @deprecated Card should not be clickable. Wrap it in a button or anchor instead. */
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

/**
 * A container component for grouping related content with an optional visible border.
 * Use the `Cards` export for a grid layout of multiple cards.
 */
function Card({ children, border, className, style, onClick }: CardProps) {
  const mergedClassName = cx(className, DEFAULT, {
    "border-gray-200": border,
    "border-white": !border
  })

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={mergedClassName} style={style} onClick={onClick}>
      {children}
    </div>
  )
}

export { Card, Cards }
export default Card
